import { components, operations } from "./apiSpec";

export type IPlanEnrollment = components["schemas"]["PlanEnrollment"];

export type IPlanEnrollmentCreateRequest =
  operations["enrollPlan"]["requestBody"]["content"]["application/json"];

export type IPlanEnrollmentListQuerySort =
  NonNullable<IPlanEnrollmentListQuery>["sort"];

export type IPlanEnrollmentListQueryFilter = {
  planType?: IPlanType;
  status?: IPlanStatus;
  endDate?: { "<"?: Date; ">"?: Date };
};

export type IPlanEnrollmentListQuery =
  operations["listPlanEnrollments"]["parameters"]["query"];

export type IPlanType = IPlanEnrollment["planType"];

export type IPlanStatus = IPlanEnrollment["status"];

export enum WorkClassification {
  Driving = "Driving",
  AutoDetailing = "AutoDetailing",
  ClaimsInspector = "ClaimsInspector",
  Clerical = "Clerical"
}
